module.exports = {
  name: "Shine",
  iconPaths: {
    favicon32: "saffron/images/favicons/favicon-32x32.png",
    favicon16: "saffron/images/favicons/favicon-16x16.png",
    appleTouchIcon: "saffron/images/favicons/apple-touch-icon-152x152.png",
    maskIcon: "saffron/images/favicons/safari-pinned-tab.svg",
    msTileImage: "saffron/images/favicons/msapplication-icon-144x144.png",
  },
  themeColor: "#4d3791",
};
